<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-tabs
        v-model="tab"
        grow
        background-color="transparent"
      >
        <v-tab v-for="item in tabItems" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
      <v-card flat>
        <v-card-title>Batch Files</v-card-title>
        <v-card-text>
          <v-data-table
            fixed-header
            :items="layoutData.complex.items"
            :headers="layoutData.complex.headers"
            :footer-props="layoutData.footerProps"
            :options.sync="layoutData.options"
            :server-items-length="layoutData.options.pageCount"
            height="500"
          >
            <template v-slot:item.action="{ item }" >
              <v-btn x-small color="primary" @click="downloadFile(item)">download</v-btn>
            </template>
            <template v-slot:item.operatedBy="{ item }" >
              {{ getFullName(item.operatedBy) }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-hover
        v-slot="{ hover }"
        open-delay="200"
      >
        <v-card
          :elevation="hover ? 16 : 2"
          :class="{ 'on-hover': hover }"
          class="mx-auto"
          color="primary"
          height="100"
          max-width="350"
          @click="displayDialogEvent"
        >
          <v-card-text class="font-weight-medium mt-6 text-white">
            <v-layout>
              <v-flex class="text-center" lg5>
                <v-icon style="font-size: 70px" color="white">fa-rocket</v-icon>
              </v-flex>
              <v-flex class="text-left mt-3" lg7>
                <span style="font-size: 32px">START</span>
                <br>
                <span style="font-size: 20px">Generate File</span>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-hover>
    </v-container>
    <v-dialog v-model="dialog.display" persistent max-width="80%">
      <arb-basic-card v-if="dialog.display" :title="dialog.title">
        <v-icon slot="widget-header-action" @click="hideDialogEvent">close</v-icon>
        <div slot="widget-content">
          <v-data-table
            :headers="dialog.complex.headers"
            :items="dialog.complex.items"
            item-key="id"
            :loading="dialog.loading"
            :footer-props="dialog.footerProps"
            :options.sync="dialog.options"
            :server-items-length="dialog.options.pageCount"
            class="p-t-5"
          >
            <template v-slot:item.fullName="{ item }">
              <td>{{ assist.tool.getFullName(item) }}</td>
            </template>
            <template v-slot:item.payrollFrequency="{ item }">
              <td>{{ assist.tool.getEnumTextByValue(assist.dataType.PayrollFrequencyEnum, item.payrollFrequency) }}</td>
            </template>
            <template v-slot:item.principal="{ item }">
              <td>{{ assist.tool.formatCurrency(item.principal) }}</td>
            </template>
            <template v-slot:item.interest="{ item }">
              <td>{{ assist.tool.formatCurrency(item.interest) }}</td>
            </template>
            <template v-slot:item.lateFee="{ item }">
              <td>{{ assist.tool.formatCurrency(item.lateFee) }}</td>
            </template>
            <template v-slot:item.nsfFee="{ item }">
              <td>{{ assist.tool.formatCurrency(item.nsfFee) }}</td>
            </template>
            <template v-slot:item.amount="{ item }">
              <td>{{ assist.tool.formatCurrency(item.amount) }}</td>
            </template>
          </v-data-table>
        </div>
        <v-btn color="primary" slot="widget-footer-enter" @click="generateEvent">generate</v-btn>
      </arb-basic-card>
    </v-dialog>
  </div>
</template>

<script>
import { LIST_TABLE_HEADER } from '@/setting/list-header/list-table-header'
import { DataType, Tool, Popup } from '@/util/index'
import { CollectionApi } from '@/api/pandaria'
const tool = new Tool()
const popup = new Popup()
export default {
  data () {
    return {
      assist: {
        dataType: DataType,
        tool: tool
      },
      layoutData: {
        complex: {
          headers: LIST_TABLE_HEADER.DOWNLOAD_FILE_HEADER,
          items: []
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          pageCount: 0
        },
        footerProps: {
          'items-per-page-options': [10, 20, 50]
        }
      },
      dialog: {
        display: false,
        title: '',
        loading: false,
        options: {
          page: 1,
          itemsPerPage: 10,
          pageCount: 0
        },
        complex: {
          headers: LIST_TABLE_HEADER.ThirdPartySendEmailHeader,
          items: []
        },
        footerProps: {
          'items-per-page-options': [10, 20, 50]
        }
      },
      tab: 0,
      tabItems: [
        'WAE', 'WAI'
      ]
    }
  },
  watch: {
    'dialog.options.page': {
      handler () {
        this.queryEmail()
      }
    },
    'dialog.options.itemsPerPage': {
      handler () {
        this.queryEmail()
      }
    },
    'layoutData.options.page': {
      handler () {
        this.getTransactionTask()
      }
    },
    'layoutData.options.itemsPerPage': {
      handler () {
        this.getTransactionTask()
      }
    },
    '$store.getters.getRuntimePortfolio': {
      handler (newVal, oldVal) {
        if (tool.compareTwoPortfolioArray(newVal, oldVal)) {
          this.getTransactionTask()
        }
      }
    },
    tab () {
      this.getTransactionTask()
    }
  },
  mounted () {
    this.getTransactionTask()
  },
  methods: {
    getFullName (operatedBy) {
      const operated = JSON.parse(operatedBy)
      if (tool.isNotEmpty(operated) && tool.isNotEmpty(operated.firstName) && tool.isNotEmpty(operated.lastName)) {
        return `${operated.firstName} ${operated.lastName}`
      }
    },
    downloadFile (item) {
      window.location.href = item.fileUrl
    },
    displayDialogEvent () {
      this.dialog.display = true
      this.dialog.title = 'Download File View'
      this.dialog.complex.items = []
      this.queryEmail()
    },
    hideDialogEvent () {
      this.dialog.display = false
    },
    generateEvent () {
      this.generateFile()
      this.dialog.display = false
    },
    queryEmail () {
      if (tool.isEmpty(this.$store.getters.getRuntimePortfolio)) {
        return
      }

      let collectionProvider
      if (this.tab === 0) {
        collectionProvider = DataType.CollectionProviderEnum.WAGE_ASSIGNMENT.value
      } else {
        collectionProvider = DataType.CollectionProviderEnum.WAGE_ASSIGNMENT_IN_HOUSE.value
      }

      this.loading = true
      const input = {
        queryType: DataType.EmailQueryType.NEED_TO_GENERATE.value,
        portfolioId: this.$store.getters.getRuntimePortfolio[0],
        pageNum: this.dialog.options.page,
        pageSize: this.dialog.options.itemsPerPage,
        collectionProvider: collectionProvider
      }
      CollectionApi.queryEmail(input, this.queryEmailCallBack)
    },
    queryEmailCallBack (res) {
      this.dialog.loading = false
      this.dialog.options.page = res.page
      this.dialog.options.itemsPerPage = res.size
      this.dialog.options.pageCount = res.total
      this.dialog.complex.items = res.data
    },
    async getTransactionTask () {
      if (tool.isEmpty(this.$store.getters.getRuntimePortfolio)) {
        return
      }
      if (this.$store.getters.getRuntimePortfolio.length > 1) {
        popup.popupForWarning('Only one portfolio can be selected in this page')
        return
      }

      let taskType
      if (this.tab === 0) {
        taskType = DataType.TaskTypeEnum.EXTERNAL_TRANSFER_TASK_FOR_WA.value
      } else {
        taskType = DataType.TaskTypeEnum.EXTERNAL_TRANSFER_TASK_FOR_WAI.value
      }

      const input = {
        pageNum: this.layoutData.options.page,
        pageSize: this.layoutData.options.itemsPerPage,
        portfolioList: this.$store.getters.getRuntimePortfolio,
        taskType: taskType
      }
      await CollectionApi.getTransactionTask(input, this.getTransactionTaskCallback)
    },
    getTransactionTaskCallback (res) {
      if (tool.isNotEmpty(res)) {
        this.layoutData.options.page = res.page
        this.layoutData.options.itemsPerPage = res.size
        this.layoutData.options.pageCount = res.total
        this.layoutData.complex.items = res.data
      }
    },
    generateFile () {
      if (tool.isEmpty(this.$store.getters.getRuntimePortfolio)) {
        popup.popupForWarning('Please select portfolio')
        return
      }
      if (this.$store.getters.getRuntimePortfolio.length > 1) {
        popup.popupForWarning('Only one portfolio can be selected in this page')
        return
      }

      let collectionProvider
      if (this.tab === 0) {
        collectionProvider = DataType.CollectionProviderEnum.WAGE_ASSIGNMENT.value
      } else {
        collectionProvider = DataType.CollectionProviderEnum.WAGE_ASSIGNMENT_IN_HOUSE.value
      }

      const $this = this
      const input = {
        portfolioId: this.$store.getters.getRuntimePortfolio[0],
        collectionProvider: collectionProvider
      }
      CollectionApi.generateFile(input, async function (res) {
        await $this.getTransactionTask()
        if (tool.isNotEmpty(res?.generatedLoanList)) {
          const generatedLoanList = res.generatedLoanList
          const result = []
          for (var i = 0; i < generatedLoanList.length; i += 3) {
            var strLoanNo = generatedLoanList.slice(i, i + 3)
            let str = strLoanNo.toString()
            str = str.replace(/,/g, ',  ')
            result.push('</br>' + str)
          }
          $this.$swal({
            type: 'info',
            title: 'These loans have already been generated with files: ',
            showCancelButton: false,
            padding: '1rem',
            margin: '1rem',
            html: `<strong>${result}</strong>`
          })
        }
      }, (error) => {
        popup.popupForWarning(error.message)
      })
    }
  }
}
</script>
